import React, { useState, useEffect } from "react";
import { db } from "../utils/firebase";
import { collection, onSnapshot } from "firebase/firestore";
import Calendar from "../components/Calendar";
import { useAuth } from "../hooks/AuthenticationProvider";

const Schedule = () => {
  const [schedule, setSchedule] = useState([]);
  const { organizationId } = useAuth();

  useEffect(() => {
    if (!organizationId) return;

    // Set up real-time listener
    const scheduleRef = collection(
      db,
      `organizations/${organizationId}/schedule`
    );
    const unsubscribe = onSnapshot(
      scheduleRef,
      (snapshot) => {
        const scheduleData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          startDate: doc.data().startDate?.toDate(),
          endDate: doc.data().endDate?.toDate(),
        }));

        setSchedule(scheduleData);
      },
      (error) => {
        console.error("Error fetching schedule:", error);
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [organizationId]);

  // Functions to update schedule state
  const handleAddEvent = (newEvent) => {
    setSchedule((prev) => [...prev, newEvent]);
  };

  const handleUpdateEvent = (updatedEvent) => {
    setSchedule((prev) =>
      prev.map((event) => (event.id === updatedEvent.id ? updatedEvent : event))
    );
  };

  const handleDeleteEvent = (eventId) => {
    setSchedule((prev) => prev.filter((event) => event.id !== eventId));
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-white">
          Schedule Management
        </h1>
      </div>

      <div className="bg-slate-800/50 backdrop-blur-xl rounded-xl border border-slate-700 p-6">
        <Calendar
          meetings={schedule}
          organizationId={organizationId}
          isCompact={false}
          onAddEvent={handleAddEvent}
          onUpdateEvent={handleUpdateEvent}
          onDeleteEvent={handleDeleteEvent}
        />
      </div>
    </div>
  );
};

export default Schedule;
